import { CustomFriendsCheckoutModel } from '../facade/custom-friends-checkout.model';

export const FRIENDS_CHECKOUT_ID = 'friendsCheckout';

export interface CustomFriendsCheckoutState {
  members: CustomFriendsCheckoutModel[];
  selected: CustomFriendsCheckoutModel;
}
